import { useState } from 'react';
import { WishlistTab } from './WishlistTab';
import { TastingNotesTab } from './TastingNotesTab';
import { ReviewedTab } from './ReviewedTab';

type SubTab = 'wishlist' | 'tasted' | 'reviewed';

const TAB_LABELS: Record<SubTab, string> = {
  wishlist: 'Wishlist',
  tasted: 'Tasted',
  reviewed: 'Reviewed',
};

export const MyWines = () => {
  const [tab, setTab] = useState<SubTab>('wishlist');

  return (
    <section>
      <div role="tablist" className="flex gap-1 border-b border-gray-200 mb-6">
        {(Object.keys(TAB_LABELS) as SubTab[]).map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={tab === key}
            onClick={() => setTab(key)}
            className={`px-4 py-2 text-sm font-sans transition-colors ${
              tab === key
                ? 'text-gray-900 border-b-2 border-primary-700 -mb-px'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {TAB_LABELS[key]}
          </button>
        ))}
      </div>
      {tab === 'wishlist' && <WishlistTab />}
      {tab === 'tasted' && <TastingNotesTab />}
      {tab === 'reviewed' && <ReviewedTab />}
    </section>
  );
};
